import React from 'react';
import {
  createStackNavigator,
  StackNavigationProp,
} from '@react-navigation/stack';
import { RouteProp } from '@react-navigation/native';
import { Platform } from 'react-native';

import LandingScreen from '../features/landing';
import ResultsScreen from '../features/results';

const tabTitle = (text: string) =>
  Platform.select({ web: text, default: 'Zonetail PMS' });

export enum RouteNames {
  Explore = 'Explore',
  Results = 'Results',
}

export type RootStackParamList = {
  Explore: { query?: string };
  Results: { query: string };
};

export type ResultsScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Results
>;

export type ResultsScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Results
>;

export type ResultsProps = {
  route: ResultsScreenRouteProp;
  navigation: ResultsScreenNavigationProp;
};

export type ExploreScreenRouteProp = RouteProp<
  RootStackParamList,
  RouteNames.Explore
>;

export type ExploreScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  RouteNames.Explore
>;

export type ExploreProps = {
  route: ExploreScreenRouteProp;
  navigation: ExploreScreenNavigationProp;
};

const ExploreStack = createStackNavigator<RootStackParamList>();

function RootNavigator() {
  return (
    <ExploreStack.Navigator initialRouteName={RouteNames.Explore}>
      <ExploreStack.Screen
        name={RouteNames.Explore}
        component={LandingScreen}
        options={{
          headerShown: false,
          title: tabTitle('Explore'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.Results}
        component={ResultsScreen}
        options={{
          headerShown: false,
        }}
      />
    </ExploreStack.Navigator>
  );
}

export default RootNavigator; // React.memo(RootNavigator);
